// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Typography, Paper } from '@mui/material';
import notFoundPage from '../../assets/images/404.png'; 

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = countdown > 0 ? setInterval(() => {
      setCountdown(countdown - 1);
    }, 1000) : navigate('/dashboard');

    return () => clearInterval(timer);
  }, [countdown, navigate]);

  return (
    <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: '100vh', backgroundColor: 'white' }}
  >
    <Paper
      elevation={3}
      style={{ width: 600, height: 600, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',marginLeft:20,marginRight:20 }}
    >
      <img src={notFoundPage} alt="404 Not Found" style={{ maxWidth: '100%', maxHeight: '80%' }} />
      <Typography variant="h4" color="#0C9FDC" gutterBottom sx={{marginBottom:1}}>
        Oops! Sayfa bulunamadı.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/dashboard')}
      >
        {countdown > 0 ? `Panele Dön (${countdown})` : 'Panele Dön'}
      </Button>
    </Paper>
  </Box>
  );
};


